(function () {
  'use strict';

  function isGameDayCollection() {
    return window.location.pathname.includes(
      '/collections/game-day-collection'
    );
  }

  async function getProduct(handle) {
    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    const response = await fetch(
      root + 'products/' + handle + '.js'
    );

    if (!response.ok) {
      throw new Error(
        'Could not load Game Day product: ' + handle
      );
    }

    return response.json();
  }

  function updateSelectedButton(card, selectedButton) {
    card
      .querySelectorAll('[data-game-day-size]')
      .forEach(function (button) {
        const selected = button === selectedButton;

        button.dataset.selected = selected
          ? 'true'
          : 'false';

        button.setAttribute(
          'aria-pressed',
          selected ? 'true' : 'false'
        );
      });
  }

  function updateQuickAdd(card, product) {
  const quickAdd = card.querySelector(
    'product-quick-add'
  );

  if (!quickAdd || !product) {
    console.warn(
      '[Game Day] Quick Add component not found.'
    );
    return;
  }

  const availableVariant =
    product.variants &&
    product.variants.find(function (variant) {
      return variant.available;
    });

  if (!availableVariant) {
    console.warn(
      '[Game Day] No available variant:',
      product.handle
    );
    return;
  }

  /*
   * Blockshop's QuickAdd connectedCallback()
   * stores these values as properties when the
   * component first initializes.
   *
   * Therefore we must update BOTH:
   *
   * 1. data attributes
   * 2. QuickAdd internal properties
   */

  quickAdd.dataset.handle = product.handle;

  quickAdd.dataset.id =
    availableVariant.id;

  quickAdd.handle =
    product.handle;

  quickAdd.query =
    '?section_id=product--quick-add--form&variant=' +
    availableVariant.id;

  /*
   * Keep data-form exactly as Blockshop originally
   * created it.
   */
  quickAdd.dataset.gameDayHandle =
    product.handle;

  quickAdd.dataset.gameDayVariantId =
    availableVariant.id;

  console.log(
    '[Game Day] Quick Add updated:',
    {
      handle: quickAdd.handle,
      variantId: availableVariant.id,
      query: quickAdd.query
    }
  );
}

function updatePrice(card, product) {
  const priceContainer = card.querySelector(
    '.product--price-container'
  );

  if (!priceContainer || !product) {
    return;
  }

  const priceElement = priceContainer.querySelector(
    '.product--price'
  );

  const compareElement = priceContainer.querySelector(
    '.product--compare-price'
  );

  const fromElement = priceContainer.querySelector(
    '.product--from'
  );

 

  /*
   * Update main selling price.
   */
  if (priceElement) {
    priceElement.textContent =
      formatMoney(product.price);
  }

  /*
   * Update compare-at price.
   */
  const showCompare =
    product.available &&
    product.compare_at_price &&
    product.compare_at_price > product.price;

  if (compareElement) {
    if (showCompare) {
      compareElement.textContent =
        formatMoney(product.compare_at_price);

      compareElement.style.display = '';
    } else {
      compareElement.style.display = 'none';
    }
  }

  /*
   * "From" is only needed when the product has
   * varying prices. Our individual Game Day
   * products normally have one price.
   */
  if (fromElement) {
    fromElement.style.display = 'none';
  }

  console.log(
    '[Game Day] Price updated:',
    formatMoney(product.price)
  );
}




function formatMoney(cents) {
  if (
    window.Shopify &&
    typeof window.Shopify.formatMoney === 'function'
  ) {
    return window.Shopify.formatMoney(
      cents,
      window.Shopify.money_format || '${{amount}}'
    );
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(cents / 100);
}

async function renderGameDayProductPrice(product) {
  if (!product || !product.handle) {
    return;
  }

  const gameDaySelector = document.querySelector(
    '[data-game-day-product-page]'
  );

  if (!gameDaySelector) {
    console.warn(
      '[Game Day] Game Day product selector not found.'
    );
    return;
  }

  /*
   * The Game Day selector lives inside the
   * product section. Get the actual section ID.
   */
  const sectionWrapper =
    gameDaySelector.closest('[data-section-id]');

  const sectionId =
    sectionWrapper?.dataset.sectionId;

  if (!sectionId) {
    console.warn(
      '[Game Day] Product section ID not found.'
    );
    return;
  }

  /*
   * The selected Game Day product is a separate
   * Shopify product. Render that product's
   * existing Blockshop product section.
   */
  const root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  /*
   * Use the selected product's actual variant.
   */
  const selectedVariant =
    product.variants &&
    product.variants.length
      ? product.variants[0]
      : null;

  if (!selectedVariant) {
    console.warn(
      '[Game Day] Selected product has no variant.'
    );
    return;
  }

  const requestUrl =
    root +
    'products/' +
    encodeURIComponent(product.handle) +
    '?section_id=' +
    encodeURIComponent(sectionId) +
    '&variant=' +
    encodeURIComponent(selectedVariant.id);

  try {

    console.log(
      '[Game Day] Rendering selected product price:',
      product.handle,
      selectedVariant.id
    );

    const response = await fetch(requestUrl, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error(
        'HTTP ' + response.status
      );
    }

    const html = await response.text();

    const parser =
      new DOMParser();

    const newDocument =
      parser.parseFromString(
        html,
        'text/html'
      );

    /*
     * Find the price block rendered by
     * Blockshop for the SELECTED product.
     */
    const newPriceBlock =
      newDocument.querySelector(
        '.product-page--block[data-block-type="price"]'
      );

    if (!newPriceBlock) {
      console.error(
        '[Game Day] Selected product price block was not returned.',
        requestUrl
      );
      return;
    }

    /*
     * Find the current price block on the page.
     */
    const currentPriceBlock =
      document.querySelector(
        '.product-page--block[data-block-type="price"]'
      );

    if (!currentPriceBlock) {
      console.error(
        '[Game Day] Current product price block not found.'
      );
      return;
    }

    /*
     * Replace ONLY the contents.
     */
    currentPriceBlock.innerHTML =
      newPriceBlock.innerHTML;

    console.log(
      '[Game Day] PRICE UPDATED:',
      product.title,
      'price:',
      selectedVariant.price,
      'compare:',
      selectedVariant.compare_at_price
    );

  } catch (error) {

    console.error(
      '[Game Day] Selected product price render failed:',
      error
    );

  }
}

function updateGameDayProductPage(product) {
  const selector = document.querySelector(
    '[data-game-day-product-page]'
  );

  if (!selector || !product) {
    return;
  }

  const productPage = selector.closest(
    '.product-page--root'
  );

  if (!productPage) {
    return;
  }

  /*
   * ------------------------------------------------
   * 1. UPDATE PRODUCT TITLE
   * ------------------------------------------------
   */

  const titleElements = productPage.querySelectorAll(
    '.product-page--title, .product-page--heading'
  );

  titleElements.forEach(function (element) {
    element.textContent = product.title;
  });

/*
 * ------------------------------------------------
 * 2. UPDATE PRICE
 * ------------------------------------------------
 */

renderGameDayProductPrice(product);

  /*
   * ------------------------------------------------
   * 3. UPDATE PRODUCT IMAGE
   * ------------------------------------------------
   */

  if (product.featured_image) {
    const mainImage =
      productPage.querySelector(
        '.product-page--desktop-container img'
      );

    if (mainImage) {
      mainImage.src =
        product.featured_image;

      mainImage.removeAttribute(
        'srcset'
      );
    }
  }


  console.log(
    '[Game Day] Product page updated:',
    {
      title: product.title,
      price: product.price,
      image: product.featured_image
    }
  );
}

async function addGameDayProductToCart(product) {
  if (!product) return;

  const variant =
    product.variants &&
    product.variants.find(function (item) {
      return item.available;
    });

  if (!variant) {
    console.warn(
      '[Game Day] Selected size is unavailable.'
    );
    return;
  }

  const productPage =
    document.querySelector(
      '[data-game-day-product-page]'
    )?.closest('.product-page--root');

  if (!productPage) return;

  const quantityInput =
    productPage.querySelector(
      'input[name="quantity"]'
    );

  const quantity = quantityInput
    ? Math.max(
        1,
        parseInt(quantityInput.value, 10) || 1
      )
    : 1;

  const addButton =
    productPage.querySelector(
      '.product-buy-buttons--primary'
    );

  if (addButton) {
    addButton.setAttribute(
      'aria-busy',
      'true'
    );
  }

  try {
    const request = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variant.id,
            quantity: quantity
          }
        ]
      })
    };

    await theme.cart.addItem(
      request,
      variant.id
    );

    theme.drawer.open(
      'right',
      'cart-drawer',
      addButton || productPage
    );

    console.log(
      '[Game Day] Product page added:',
      product.title,
      'variant:',
      variant.id,
      'quantity:',
      quantity
    );

  } catch (error) {
    console.error(
      '[Game Day] Product page add-to-cart failed:',
      error
    );

  } finally {
    if (addButton) {
      addButton.setAttribute(
        'aria-busy',
        'false'
      );
    }
  }
}

async function selectGameDayProductPageSize(
  button
) {
  const handle =
    button.dataset.productHandle;

  if (!handle) return;

  const selector =
    button.closest(
      '[data-game-day-product-page]'
    );

  if (!selector) return;

  if (selector.dataset.loading === 'true') {
    return;
  }

  selector.dataset.loading = 'true';

  try {
    const product =
      await getProduct(handle);

    /*
     * Update selected button
     */
    selector
      .querySelectorAll(
        '[data-game-day-product-size]'
      )
      .forEach(function (sizeButton) {
        const selected =
          sizeButton === button;

        sizeButton.classList.toggle(
          'is-selected',
          selected
        );

        sizeButton.setAttribute(
          'aria-pressed',
          selected
            ? 'true'
            : 'false'
        );

        if (selected) {
          sizeButton.setAttribute(
            'aria-current',
            'true'
          );
        } else {
          sizeButton.removeAttribute(
            'aria-current'
          );
        }
      });

    /*
     * Remember the selected real product.
     */
    selector.dataset.currentHandle =
      product.handle;

    /*
     * Update product-page price.
     */
    updateGameDayProductPage(
  product
);

/*
 * Re-apply the display price after
 * Blockshop finishes its native update.
 */



/*
 * Store selected product for Add to Cart.
 */
selector.gameDaySelectedProduct =
  product;

    console.log(
      '[Game Day] Product page size selected:',
      product.title,
      '→',
      product.handle
    );

  } catch (error) {
    console.error(
      '[Game Day] Product page size selection failed:',
      error
    );

  } finally {
    delete selector.dataset.loading;
  }
}

function bindGameDayProductPage() {
  const selector =
    document.querySelector(
      '[data-game-day-product-page]'
    );

  if (!selector) return;

  if (
    selector.dataset.gameDayPageBound === 'true'
  ) {
    return;
  }

  selector.dataset.gameDayPageBound =
    'true';

  selector
    .querySelectorAll(
      '[data-game-day-product-size]'
    )
    .forEach(function (button) {
      button.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          selectGameDayProductPageSize(
            button
          );
        }
      );
    });
}

function bindGameDayProductPageCart() {
  const selector =
    document.querySelector(
      '[data-game-day-product-page]'
    );

  if (!selector) return;

  const productPage =
    selector.closest(
      '.product-page--root'
    );

  if (!productPage) return;

  const addButton =
    productPage.querySelector(
      '.product-buy-buttons--primary'
    );

  if (!addButton) return;

  if (
    addButton.dataset.gameDayCartBound ===
    'true'
  ) {
    return;
  }

  addButton.dataset.gameDayCartBound =
    'true';

  addButton.addEventListener(
    'click',
    async function (event) {
      const selectedProduct =
        selector.gameDaySelectedProduct;

      if (!selectedProduct) {
        /*
         * If the customer hasn't clicked our
         * Game Day selector yet, allow Blockshop
         * to behave normally.
         */
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      await addGameDayProductToCart(
        selectedProduct
      );
    },
    true
  );
}

async function addGameDayCollectionProductToCart(
  card,
  button
) {
  if (!card || !button) {
    return;
  }

  /*
   * Get the currently selected size.
   */
  const selectedSize =
    card.querySelector(
      '.game-day-product--size[aria-pressed="true"]'
    );

  if (!selectedSize) {
    console.warn(
      '[Game Day] Please select a size first.'
    );
    return;
  }

  const handle =
    selectedSize.dataset.productHandle;

  if (!handle) {
    console.warn(
      '[Game Day] Selected size has no product handle.'
    );
    return;
  }

  button.disabled = true;

  const originalText =
    button.textContent;

  button.textContent =
    'ADDING...';

  try {

    /*
     * Get the actual Shopify product.
     */
    const product =
      await getProduct(handle);

    if (!product) {
      throw new Error(
        '[Game Day] Selected product not found.'
      );
    }

    /*
     * Get the available variant.
     */
    const variant =
      product.variants &&
      product.variants.find(function (item) {
        return item.available;
      });

    if (!variant) {
      throw new Error(
        '[Game Day] Selected size is unavailable.'
      );
    }

    /*
     * Add selected variant to cart.
     */
    const request = {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variant.id,
            quantity: 1
          }
        ]
      })
    };

    await theme.cart.addItem(
      request,
      variant.id
    );

    /*
     * Open Blockshop cart drawer.
     */
    theme.drawer.open(
      'right',
      'cart-drawer',
      button
    );

    button.textContent =
      'ADDED';

    console.log(
      '[Game Day] Collection product added:',
      product.title,
      'variant:',
      variant.id
    );

    setTimeout(function () {
      button.textContent =
        originalText;

      button.disabled = false;
    }, 1200);

  } catch (error) {

    console.error(
      '[Game Day] Collection add-to-cart failed:',
      error
    );

    button.textContent =
      'TRY AGAIN';

    setTimeout(function () {
      button.textContent =
        originalText;

      button.disabled = false;
    }, 1500);

  }
}

  async function selectSize(card, button) {
  const handle = button.dataset.productHandle;

  if (!handle) {
    console.error(
      '[Game Day] No product handle found.'
    );
    return;
  }

  if (card.dataset.loadingSize === 'true') {
    return;
  }

  card.dataset.loadingSize = 'true';

  try {
    /*
     * Get the actual Shopify product for the
     * selected size.
     */
    const product = await getProduct(handle);

    /*
     * Highlight the selected size.
     */
    updateSelectedButton(
  card,
  button
);

updateQuickAdd(
  card,
  product
);

updatePrice(
  card,
  product
);
/*
 * Remember the selected Game Day product
 * for the collection Add to Cart button.
 */
card.gameDaySelectedProduct =
  product;

/*
 * Enable the collection Add to Cart button.
 */
const addButton =
  card.querySelector(
    '[data-game-day-add-to-cart]'
  );

if (addButton) {
  addButton.disabled = false;
}

    /*
     * Use Blockshop's existing Quick Add
     * cart functionality immediately.
     */
    const quickAdd = card.querySelector(
      'product-quick-add'
    );

    if (!quickAdd) {
      throw new Error(
        '[Game Day] Quick Add component not found.'
      );
    }

    /*
     * Give the browser a moment to apply the
     * updated handle/variant properties before
     * calling Blockshop's addToCart().
     */
    await new Promise(function (resolve) {
      requestAnimationFrame(resolve);
    });

    

    card.dataset.currentHandle =
      product.handle;

    console.log(
      '[Game Day] Added to cart:',
      product.title,
      '→',
      product.handle
    );

  } catch (error) {
    console.error(
      '[Game Day] Size selection/add-to-cart failed:',
      error
    );

  } finally {
    delete card.dataset.loadingSize;
  }
}

function bindGameDayCards() {
  if (!isGameDayCollection()) return;

  const cards = document.querySelectorAll(
    '[data-game-day-product]'
  );

  cards.forEach(function (card) {

    if (card.dataset.gameDayBound === 'true') {
      return;
    }

    card.dataset.gameDayBound = 'true';

    /*
     * SIZE BUTTONS
     */
    card
      .querySelectorAll('[data-game-day-size]')
      .forEach(function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();

            selectSize(
              card,
              button
            );

          }
        );

      });


    /*
     * ADD TO CART BUTTON
     */
    const addButton =
      card.querySelector(
        '[data-game-day-add-to-cart]'
      );

    if (addButton) {

      addButton.addEventListener(
        'click',
        async function (event) {

          event.preventDefault();
          event.stopPropagation();

          await addGameDayCollectionProductToCart(
            card,
            addButton
          );

        }
      );

    }

  });
}

  function init() {
  bindGameDayCards();
  bindGameDayProductPage();
  bindGameDayProductPageCart();
}

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
  'shopify:section:load',
  function () {
    bindGameDayCards();
    bindGameDayProductPage();
    bindGameDayProductPageCart();
  }
);

})();